
import { setCartCount } from "../store/cartSlice";
import { toast } from "react-toastify";

const addToCart = async (productId, variant, dispatch) => {

  if (!variant) {
    toast.error("Select variant");
    return;
  }

  try {

    const response = await fetch(
      "https://lappyshop.onrender.com/api/addtocart",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          productId: productId,
          ram: variant.ram,
          storage: variant.storage,
          price: Number(variant.price)
        })
      }
    );

    const data = await response.json();

    if (data.success) {
      toast.success("Added to cart");
    } else {
      toast.info(data.message);
    }

    // cart count update

    const countResponse = await fetch(
      "https://lappyshop.onrender.com/api/countAddToCartProduct",
      {
        credentials: "include"
      }
    );

    const countData = await countResponse.json();

    if (countData.success) {
      dispatch(setCartCount(countData.data.count));
    }

  } catch (error) {

    console.error(error);
    toast.error("Cart error");

  }

};

export default addToCart;